import { IContentfulRichTextResponse } from "../types/IContentfulRichText";

export const getPlainText = (heading1: IContentfulRichTextResponse) => JSON.parse(heading1?.raw as string).content.reduce(
  (acc: string, block: any) =>
    acc + block.content.reduce((accContent: string, blockContent: any) => accContent + blockContent.value, ""),
  "",
);
